<template>
    <div class="invoice">
        <el-container>
            <el-main ref="main">
                <el-tabs  v-model="activeName" style="width: 100%">
                    <el-tab-pane label="基本信息" name="Tab1" style="height: 700px;overflow-y: auto">
                        <div>
                            <div class="container">
                                <div class="titleBox">
                                    <div>申请信息：</div>
                                    <!--                                <div class="titleNum">编号：1234567</div>-->
                                </div>
                                <el-form class="dataFormBox" :inline="true" :model="dataForm">
                                    <el-row>
                                        <el-col :span="12">
                                            <el-form-item label-width="120px" label="项目部：">
                                                <el-select v-model="dataForm.projectDeptId" placeholder="请选择项目部"  @change="getProjectList">
                                                    <el-option :label="deptItem.applyDeptName" :value="deptItem.applyDeptId" v-for="(deptItem,deptIndex) in deptList" :key="'deptItem'+deptIndex"></el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label-width="120px" label="项目名称：">
                                                <el-select v-model="dataForm.projectId" placeholder="请选择项目名称" @change="getProjectAddress">
                                                    <el-option :label="projectItem.name" :value="projectItem.id" v-for="(projectItem,projectIndex) in projectList" :key="'projectItem'+projectIndex"></el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label-width="120px" label="欠款单位：">
                                                <el-input v-model="dataForm.debtName" disabled placeholder="请输入欠款单位" clearable></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label-width="120px" label="项目地点：">
                                                <el-input v-model="dataForm.projectAddress" disabled placeholder="请输入项目地点" clearable></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label-width="120px" label="发票抬头：">
                                                <el-input v-model="dataForm.billHead" placeholder="请输入发票抬头" clearable></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label-width="120px" label="纳税人识别号：">
                                                <el-input v-model="dataForm.billTaxNumber" placeholder="请输入纳税人识别号" clearable></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label-width="120px" label="地址：">
                                                <el-input v-model="dataForm.address" placeholder="请输入地址" clearable></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label-width="120px" label="电话：">
                                                <el-input v-model="dataForm.phone" placeholder="请输入电话" clearable></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label-width="120px" label="开户行：">
                                                <el-input v-model="dataForm.bank" placeholder="请输入开户行" clearable></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label-width="120px" label="账号：">
                                                <el-input v-model="dataForm.bankAccount" placeholder="请输入账号" clearable></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label-width="120px" label="发票类型：">
                                                <el-select v-model="dataForm.category" placeholder="请选择发票类型">
                                                    <el-option label="增值税专用发票" :value="1"></el-option>
                                                    <el-option label="普通发票" :value="2"></el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label-width="120px" label="发票种类：">
                                                <el-select v-model="dataForm.type" placeholder="请选择发票种类">
                                                    <el-option label="电子发票" :value="1"></el-option>
                                                    <el-option label="纸质发票" :value="2"></el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label-width="120px" label="税率（%）：">
                                                <el-input v-model="dataForm.taxRatio" placeholder="请输入税率" clearable
                                                          @input="limitInput($event,'taxRatio')"
                                                          @blur="setPriceNum"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label-width="120px" label="发票金额：">
                                                <el-input v-model="dataForm.price" placeholder="请输入发票金额" clearable
                                                          @input="limitInput($event,'price')"
                                                          @blur="setPriceNum"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label-width="120px" label="不含税金额：">
                                                <el-input v-model="dataForm.notTaxPrice" placeholder="请输入不含税金额" clearable disabled></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label-width="120px" label="税额：">
                                                <el-input v-model="dataForm.taxPrice" placeholder="请输入税额" clearable disabled></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="24">
                                            <el-form-item style="width: 100%" label-width="120px" label="发票备注：">
                                                <el-input v-model="dataForm.remark" show-word-limit
                                                          type="textarea" :rows="2" maxlength="200"
                                                          placeholder="请输入发票备注" clearable></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-form>
                                <div class="titleBox">
                                    <div>其他信息：</div>
                                </div>
                                <el-form class="dataFormBox" :inline="true" :model="userForm">
                                    <el-row>
                                        <el-col :span="12">
                                            <el-form-item label-width="120px" label="申请人：">
                                                <el-input v-model="dataForm.currentUserName" disabled placeholder="请输入申请人" clearable></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-form>
                                <div class="titleBox" style="display: flex;justify-content: space-between;align-items: center">
                                    <div>收款记录：</div>
                                    <el-button type="primary" @click="setIsShowSelectRecord()">选择记录</el-button>
                                </div>
                            </div>
                            <div style="margin: 30px 20px 0;">
                                <collection-records :tableData="selectRecordList" ></collection-records>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="附件" name="Tab2" style="height: 700px;overflow-y: auto">
                        <upload-file
                                :tableList="fileList"
                                @submit="doSubmitFiles">
                        </upload-file>
                    </el-tab-pane>
                    <el-tab-pane label="审批流程" name="Tab3" style="overflow-y: auto">
                        <el-form
                                ref="approveRef"
                                :model="approveForm"
                                label-width="200px"
                                style="text-align: left;">
                                <el-form-item
                                        v-for="(item, index) in approveList"
                                        :key="index"
                                        :label="`${item.jobName}：`"
                                        required>
                                    <el-input style="width: 70%;" v-model="item.approveUserName" clearable></el-input>
                                    <el-button @click="selectApproveTarget(item)" type="primary">选择</el-button>
                                </el-form-item>
                        </el-form>
                    </el-tab-pane>
                </el-tabs>

            </el-main>
            <el-footer class="container">
                <div class="btnMid">
                    <el-button type="primary" @click="submit()">提 交</el-button>
                    <el-button type="info" @click="reset()">取 消</el-button>
                </div>
            </el-footer>
        </el-container>


        <approve-dialog
                :visible="approveDialogVisible"
                @close="approveDialogClose"
                title="选择审批人员"
                v-bind="approveDialogOptions"
        ></approve-dialog>

        <el-dialog
                title="提示"
                :visible.sync="isShowSelectRecord"
                width="70%"
                :before-close="handleClose">
            <collection-records ref="collectionRecords" :tableData="tableData" :isShowSelect="true"></collection-records>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isShowSelectRecord = false">取 消</el-button>
                <el-button type="primary" @click="confirmBtn">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
    import Consts from "@/utils/consts";
    import {
        getApproveListService,
    } from "@/services/sysSettingService";
    import ApproveDialog from "../../meeting/bill/ApproveDialog";
    import {
        getDeptListService,
        getProjectListService,
        setApproveService,
        getProjectAddressService,
        getReceiptsSItemsListService,
    } from '@/services/invoiceServices'
    import {createApproveProcessService} from "@/services/engineering";
    import UploadFile from "./uploadFile";
    import CollectionRecords from './collection-records'
    export default {
        name: "sales-apply",
        data(){
            return {
                dataForm:{
                    projectDeptId:'',
                    projectId:'',
                    debtName: '',
                    projectAddress: '',
                    billHead: '',
                    billTaxNumber: '',
                    address: '',
                    phone: '',
                    bank: '',
                    bankAccount: '',
                    notTaxPrice: '',
                    taxPrice: '',
                    taxRatio: '',
                    price: '',
                    remark: '',
                    type: '',
                    category: '',
                    currentUserName: sessionStorage.getItem('name')
                },
                fileList:[],
                tableData:[],
                userForm:{
                    licenseNumber:'',
                },
                activeName: 'Tab1',

                approveDialogVisible: false,
                approveDialogOptions: {
                    approveVO: {},
                }, // 审批流弹出框的配置
                approveForm: {
                    headOfDepart: {
                        // 部门负责人
                        id: null,
                        name: "",
                    },
                    leaderOfCompany: {
                        // 集团分管领导
                        id: null,
                        name: "",
                    },
                }, // 审批流程
                approveList: [], // 审批流列表

                deptList:[], //项目部列表
                projectList:[], //项目列表

                isShowSelectRecord: false,
                selectRecordList: [],
            }
        },
        components: {
            ApproveDialog,
            UploadFile,
            CollectionRecords,
        },
        methods:{
            onActive(menuCode) {
                this.initApproveList(); // 新建提报单，要先去获取一次审批流模板
                this.getDeptList();
            },
            /**
             *  获取项目部列表
             * */
            getDeptList(){
                getDeptListService().then( res => {
                    if(res.code == 10000000){
                        this.deptList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            /**
             * 获取项目列表
             * */
            getProjectList(){
                this.dataForm.projectId = '';
                let paramsData = {
                    deptId: this.dataForm.projectDeptId
                }
                getProjectListService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.projectList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            /**
             * 获取项目地址信息
             * */
            getProjectAddress(){
                if(!this.dataForm.projectId){
                    return
                }
                this.getReceiptsList();
                let paramsData = {
                    projectId: this.dataForm.projectId
                }
                getProjectAddressService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.dataForm.projectAddress = res.data.address;
                        this.dataForm.debtName = res.data.partyA;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            /**
             * 查询收款详情期数列表
             * */
            getReceiptsList(){
                let paramsData = {
                    projectId: this.dataForm.projectId
                }
                getReceiptsSItemsListService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.tableData = res.data;
                        this.selectRecordList = [];
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            /**
             * 获取审批流列表
             * */
            initApproveList() {
                let params = {
                    orgId: sessionStorage.getItem("orgId"),
                    type: "salesInput",
                };
                getApproveListService(params)
                    .then((res) => {
                        if (res.code == Consts.Code_OK) {
                            let list = res.data || [];
                            list.forEach((item) => {
                                item.approveUserId = null;
                                item.approveUserName = "";
                                item.deptId = null;
                                item.deptName = "";
                                item.sort = item.sortId;
                            });
                            list.sort((a, b) => {
                                return a.sortId - b.sortId;
                            }); // 按照sortId排序，从小到大
                            this.approveList = [...list];
                        } else if (res.code == Consts.Code_Err) {
                            this.$alert(res.msg, "提示");
                        } else {
                            this.$alert(Consts.Err_Msg, "提示");
                        }
                    })
                    .catch((error) => {
                        this.$message.error(Consts.Err_Msg);
                    });
            },
            submit(){
                if(!this.dataForm.projectDeptId ||!this.dataForm.projectId ||
                    !this.dataForm.billHead ||!this.dataForm.billTaxNumber ||!this.dataForm.address ||!this.dataForm.phone ||
                    !this.dataForm.bank ||!this.dataForm.bankAccount ||!this.dataForm.notTaxPrice ||
                    !this.dataForm.taxPrice ||!this.dataForm.taxRatio ||!this.dataForm.price ||!this.dataForm.remark){
                    this.$message.error('请完善申请信息');
                    return
                }
                if(this.selectRecordList.length == 0 ){
                    this.$message.error('收款记录为空，禁止提交发票申请');
                    return
                }
                let isApprove = this.approveList.findIndex(item => item.approveUserId == null || item.approveUserId == ''|| item.approveUserName == '')
                if(isApprove != -1){
                    this.$message.error('请完善审批流程');
                    return
                }
                let receiptItemIdList = this.selectRecordList.map(item => item.id)

                let params = {
                    ...this.dataForm,
                    attachmentList: this.fileList,
                    approveProcessCreateDtoList: this.approveList,
                    receiptItemIdList: receiptItemIdList,
                }

                this.setApprove(params);
            },
            reset(){
                this.bus.$emit("tabClose", "salesApply");
                this.bus.$emit("navMenuChange", {
                    routeId: "salesInvoice"
                });
            },
            /**
             * 提交申请
             * */
            setApprove(params){
                setApproveService(params).then( res => {
                    if(res.code == 10000000){
                        this.createApprove(res.data);
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            //创建审批流
            createApprove(id){
              let params = {
                approveClass: 'OUTPUT_BILL_APPROVE',
                approveProcessDtoList: this.approveList,
                approveStatusEnum:'UNDERAPLLY',
                projectId: this.dataForm.projectId,
                itemId: id,
                itemName: `${sessionStorage.getItem('name')}关于${this.dataForm.debtName}的销项发票申请`,
              }
              createApproveProcessService(params).then((res) => {
                if (res.code == Consts.Code_OK) {
                  this.$message.success('申请提交成功');
                  this.reset();
                } else if (res.code == Consts.Code_Err) {
                  this.$alert(res.msg, "提示");
                } else {
                  this.$alert(Consts.Err_Msg, "提示");
                }
              }).catch((error) => {
                this.$message.error(Consts.Err_Msg);
              });
            },
            selectApproveTarget(item) {
                // 选择对应的审批人
                this.approveDialogOptions = {
                    approveVO: item,
                };
                this.approveDialogVisible = true;
            },
            approveDialogClose(data) {
                console.log("审批流程,关闭", data);
                this.approveDialogVisible = false;
                if (data) {
                    // 选了人了
                    this.approveList.forEach((item) => {
                        if (item.jobId == data.jobId) {
                            item.approveUserId = data.id;
                            item.approveUserName = data.displayName || data.name;
                            item.deptId = data.deptId;
                            item.deptName = data.deptDisplayName;
                            // item.jobId = data.jobId;
                            // item.jobName = data.jobName;
                        }
                    });
                }
            },
            // tabbar切换
            handletabClick(tab, event){
                console.log(tab)
            },
            /**
             * 计算发票金额
             * 发票金额=税额+不含税
             * */
            setPriceNum(){
                if(!this.dataForm.taxRatio|| !this.dataForm.price){
                    return
                }
                this.dataForm.notTaxPrice = (Number(this.dataForm.price) / (1 + Number(this.dataForm.taxRatio)/100)).toFixed(2)
                this.dataForm.taxPrice = (Number(this.dataForm.price) - Number(this.dataForm.notTaxPrice)).toFixed(2)
            },
            limitInput(value, name) {
                let val = (value && value.split("")) || [];
                let reg1 = /\d/;
                let reg2 = /\./;
                // 第一个字符不能为小数点
                if (val[0] == ".") {
                    this.dataForm[name] = "";
                    return;
                }
                // 过滤掉除数字和小数点外的字符
                val = val.filter((e) => reg1.test(e) || reg2.test(e));
                // 匹配小数点后只能有两位小数
                // 解释一下这个match正则规格
                // ^\d* 是指以数字开头，后面允许输入0到多位数字
                // (\.?) 是指只允许一个小数点
                // \d{0,2} 是指只允许0到2位小数
                this.dataForm[name] = val.join("").match(/^\d*(\.?\d{0,2})/g)[0] || null;
            },

            // 修改附件列表后的回调
            doSubmitFiles(files) {
                console.log("doSubmitFiles====", files);
                this.fileList = files;
            },

            setIsShowSelectRecord(){
                if(!this.dataForm.projectId){
                    this.$message.error("请选择项目名称");
                    return
                }
                this.isShowSelectRecord = true
            },
            confirmBtn(){
                this.selectRecordList = this.$refs.collectionRecords.multipleSelection
                this.handleClose();
            },
            handleClose(){
                this.isShowSelectRecord = false
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/css/commonLayout.scss";
    .invoice {
        height: 100%;
        background-color: white;
        display: flex;
        flex-direction: column;
        .container{
            width: 900px;
        }
    }
    /deep/.el-textarea{
        width: 600px;
    }
    /deep/.el-tabs__header{
        padding-right: 0 !important;
        .el-tabs__nav-wrap{
            padding-left: 30px;
        }
    }
    .titleBox{
        display: flex;
        color: rgba(16, 16, 16, 100);
        font-size: 16px;
        text-align: left;
        font-family: SourceHanSansSC-regular;
        font-weight: 600;
        border-bottom: 1px solid rgba(187, 187, 187, 100);
        margin:30px 20px 0;
        padding-bottom: 10px;
        .titleNum{
            margin-left: 30px;
        }
    }
    .dataFormBox{
        margin:30px 20px;
    }
    .btnMid {
        width: 300px;
        margin: 0 auto;
        display: flex;
        justify-content: space-around;
    }
</style>
